module.exports = __webpack_public_path__ + "static/media/cn.7503c8c1.svg";